<div class="my-box" [style.max-width]="(page$ | async)?.maxWidth || '1200px'">
  @if ((translations$ | async)?.length) {
    <router-outlet></router-outlet>
  }
  <ng-http-loader></ng-http-loader>
  @if ((translations$ | async)?.length) {
    <app-cookies></app-cookies>
  }
</div>
